module.exports = {
  base: "'Source Sans Pro', sans-serif",
  code: "'Source Code Pro', monospace"
};